import React from 'react';
import { CurrentStop } from '../driverActiveDeliveriesTypes';
import styles from './CurrentStopBanner.module.css';

interface CurrentStopBannerProps {
  stop: CurrentStop;
}

export const CurrentStopBanner: React.FC<CurrentStopBannerProps> = ({ stop }) => {
  return (
    <div className={styles.wrap}>
      <h2 className={styles.heading}>
        Stop #{stop.number} — {stop.name}
      </h2>
      <div className={styles.banner}>
        <span className={styles.icon}>📍</span>
        <p className={styles.text}>{stop.message}</p>
      </div>
    </div>
  );
};
